import BaseRequest from './BaseRequest';
import { Store } from '../../store';
import { toggleLoading } from '../../store/ducks/pageConfig';
import {
    addLog,
    changeAcervosFiltrados,
    changeSearch,
    limparFiltros,
} from '../../store/ducks/pesquisa';
import { APIHelper } from '../helpers';
import { API_URL } from '../config/config';
import { VERSAO_PESQUISA_COMPLETA, VERSAO_PESQUISA_PAGINADA } from '../const';

const ConsultaRequest = () => {
    return {
        buscarConsulta(tipoConsulta, parametros, searchUrl, callback, consultaPaginada = false, cancelToken = null) {
            Store.dispatch(toggleLoading(true));

            if (!consultaPaginada) {
                //Limpa os filtros previamente selecionados
                Store.dispatch(limparFiltros());
                Store.dispatch(changeAcervosFiltrados([]));
            }

            //Se for target e NÃO possuir produto selecionado, retorna pesquisa vazia
            if (parametros.base === 'target_gedweb' && !parametros.coluna_um) {
                const consulta = {
                    data: [],
                    total: 0,
                    id: parametros.search_id,
                    base: parametros.base,
                    pesquisa: parametros.search_tab,
                };
                Store.dispatch(changeSearch(consulta));
                Store.dispatch(toggleLoading(false));
                return;
            }

            /* 11/04/2023 Removido pois estava impedindo pesquisa com caracteres não alfanuméricos
            if (parametros && parametros['termo_pesquisa']) {
                parametros['termo_pesquisa'] = diacritics.remove(parametros['termo_pesquisa']);
                parametros['termo_pesquisa'] = parametros['termo_pesquisa'].replace(/[^a-zA-Z0-9 ]/g, " ");
            }
            */

            const apiFunction = consultaPaginada
                ? this.consultaPaginada
                : this.consulta;

            apiFunction(parametros, cancelToken)
                .then(response => {
                    this.processarResultadoConsulta(
                        response,
                        parametros,
                        searchUrl,
                        tipoConsulta,
                    );
                    Store.dispatch(toggleLoading(false));
                })
                .catch(error => {
                    APIHelper.tratarErro(error);
                    Store.dispatch(changeSearch('error'));
                    Store.dispatch(toggleLoading(false));
                })
                .finally(() => {
                    //Executa o callback passado
                    if (callback) {
                        callback();
                    }
                });
        },
        processarResultadoConsulta(
            response,
            parametros,
            searchUrl,
            tipoConsulta,
        ) {
            let consulta = {};
            if (response.data) {
                if (Array.isArray(response.data)) {
                    // Pesquisa v1 - completa
                    consulta = {
                        searchVersion: VERSAO_PESQUISA_COMPLETA,
                        data: response.data,
                        total: response.data.length,
                        id: parametros.search_id,
                        base: parametros.base || 'local',
                        pesquisa: parametros.search_tab,
                    };
                } else {
                    // Pesquisa v2 - paginada
                    consulta = {
                        searchVersion: VERSAO_PESQUISA_PAGINADA,
                        data: response.data.registros,
                        total: response.data.totalRegistros,
                        id: response.data.sessao,
                        base: parametros.base || 'local',
                        pesquisa: parametros.search_tab,
                    };
                }

                if (consulta.id !== Store.getState().pesquisa.consulta?.id) {
                    //Grava entrada no histórico
                    Store.dispatch(
                        addLog({
                            id: consulta.id,
                            campos: [
                                ...Store.getState().pesquisa.opcoesConsulta.map(o =>
                                    ({ ...o}),
                                ),
                            ],
                            registros: consulta.total,
                            pesquisa: tipoConsulta,
                            url: searchUrl,
                            base: parametros.base || 'local',
                        }),
                    );
                }

                //Grava a pesquisa no redux
                Store.dispatch(changeSearch(consulta));
            } else {
                Store.dispatch(changeSearch('error'));
            }
        },
        consulta(form, cancelToken = null) {
            return BaseRequest.axiosInst.get(`${API_URL}/consulta`, {
                params: form,
                headers: BaseRequest.privateOrPublicHeaders(),
                cancelToken
            });
        },
        consultaPaginada(form, cancelToken = null) {
            const { search_id, search_tab, ...restForm } = form;
            return BaseRequest.axiosInst.get(`${API_URL}/v2/consulta/${search_tab}/${search_id}`, {
                params: restForm,
                headers: BaseRequest.privateOrPublicHeaders(),
                cancelToken
            });
        },
        ordenacao(cancelToken) {
            return BaseRequest.axiosInst.get(`${API_URL}/consulta/ordenacao`, {
                headers: BaseRequest.publicHeaders(),
                cancelToken,
            });
        },
        buscarFiltros(guiaPesquisa, cancelToken) {
            return BaseRequest.axiosInst.get(`${API_URL}/consulta/filtros`, {
                params: {
                    search_tab: guiaPesquisa,
                },
                headers: BaseRequest.publicHeaders(),
                cancelToken,
            });
        },
        buscarFiltrosConsultaPaginada(guiaPesquisa, sessao, parametros = {}) {
            return BaseRequest.axiosInst.get(`${API_URL}/v2/consulta/${guiaPesquisa}/${sessao}/filtros`, {
                headers: BaseRequest.publicHeaders(),
                params: {
                    ...parametros,
                }
            });
        },
        buscarOpcoesArquivo(cancelToken) {
            return BaseRequest.axiosInst.get(
                `${API_URL}/consulta/opcoes-arquivo`,
                { headers: BaseRequest.publicHeaders(), cancelToken },
            );
        },
        buscarOpcoesAtosNormativos(cancelToken) {
            return BaseRequest.axiosInst.get(
                `${API_URL}/consulta/opcoes-atos-normativos`,
                { headers: BaseRequest.publicHeaders(), cancelToken },
            );
        },
        buscarTitulosAdicionaisAcervos(acervos, cancelToken = null) {
            return BaseRequest.axiosInst.get(
                `${API_URL}/consulta/titulos-adicionais`,
                {
                    params: { acervos },
                    headers: BaseRequest.publicHeaders(),
                    cancelToken,
                },
            );
        },
        buscarAcervosIndexadosAcervos(acervos, cancelToken = null) {
            return BaseRequest.axiosInst.get(
                `${API_URL}/consulta/acervos-indexados`,
                {
                    params: { acervos },
                    headers: BaseRequest.publicHeaders(),
                    cancelToken,
                },
            );
        },
        buscarOpcoesConsultaIndice(cancelToken) {
            return BaseRequest.axiosInst.get(
                `${API_URL}/consulta/opcoes-indice`,
                { headers: BaseRequest.publicHeaders(), cancelToken },
            );
        },
        buscarProdutosTarget(termoPesquisa) {
            return BaseRequest.axiosInst.get(
                `${API_URL}/consulta/produtos-target`,
                {
                    params: { termoPesquisa },
                    headers: BaseRequest.privateOrPublicHeaders(),
                },
            );
        },
        buscarDisciplinas(searchString,codDepartamento, page){
            return BaseRequest.axiosInst.get(
                `${API_URL}/consulta/disciplinas`,
                {
                    params: { search_text: searchString ?? '', page: page ?? 1, codDepartamento },
                    headers: BaseRequest.privateOrPublicHeaders(),
                },
            );
        },
        buscarCursos(searchString, page){
            return BaseRequest.axiosInst.get(
                `${API_URL}/consulta/cursos`,
                {
                    params: { search_text: searchString ?? '', page: page ?? 1},
                    headers: BaseRequest.privateOrPublicHeaders(),
                },
            );
        },
        buscarProfessores(searchString, page){
            return BaseRequest.axiosInst.get(
                `${API_URL}/consulta/professores`,
                {
                    params: {search_text: searchString ?? '', page: page ?? 1},
                    headers: BaseRequest.privateOrPublicHeaders(),
                },
            );
        },
        buscarCampus(searchString, page){
            return BaseRequest.axiosInst.get(
                `${API_URL}/consulta/campus`,
                {
                    params: { search_text: searchString ?? '', page: page ?? 1},
                    headers: BaseRequest.privateOrPublicHeaders(),
                },
            );
        },
        buscarBibliotecas(searchString, page, codCampus = null){
            return BaseRequest.axiosInst.get(
                `${API_URL}/consulta/bibliotecas`,
                {
                    params: { search_text: searchString ?? '', page: page ?? 1, codCampus},
                    headers: BaseRequest.privateOrPublicHeaders(),
                },
            );
        },
        buscarProfessorPorCodigo: (cod_professor) => {
            return BaseRequest.axiosInst.get(
                `${API_URL}/consulta/professor/${cod_professor}`,
                {
                    headers: BaseRequest.privateOrPublicHeaders(),
                },
            );
        },
        buscarCursoPorCodigo: (cod_departamento) => {
            return BaseRequest.axiosInst.get(
                `${API_URL}/consulta/curso/${cod_departamento}`,
                {
                    headers: BaseRequest.privateOrPublicHeaders(),
                },
            );
        },
        buscarCampusPorCodigo: (cod_campus) => {
            return BaseRequest.axiosInst.get(
                `${API_URL}/consulta/campus/${cod_campus}`,
                {
                    headers: BaseRequest.privateOrPublicHeaders(),
                },
            );
        },
        buscarDisciplinaPorCodigo: (cod_disciplina) => {
            return BaseRequest.axiosInst.get(
                `${API_URL}/consulta/disciplina/${cod_disciplina}`,
                {
                    headers: BaseRequest.privateOrPublicHeaders(),
                },
            );
        },
        buscarBibliotecaPorCodigo: (cod_biblioteca) => {
            return BaseRequest.axiosInst.get(
                `${API_URL}/consulta/biblioteca/${cod_biblioteca}`,
                {
                    headers: BaseRequest.privateOrPublicHeaders(),
                },
            );
        },
        buscarImagemPadrao(cancelToken = null){
            return BaseRequest.axiosInst.get(
                `${API_URL}/consulta/imagem-padrao`,
                {
                    headers: BaseRequest.privateOrPublicHeaders(),
                    cancelToken
                },
            );
        },
        legislacaoAutoSearchPermission(cancelToken = null){
            return BaseRequest.axiosInst.get(
                `${API_URL}/consulta/legislacao/auto-search-permission`,
                {
                    headers: BaseRequest.privateOrPublicHeaders(),
                    cancelToken
                },
            );
        },
        getOptionsJurisprudencia(cancelToken) {
            return BaseRequest.axiosInst.get(
                `${API_URL}/consulta/jurisprudencia-options`,
                { headers: BaseRequest.publicHeaders(), cancelToken },
            );
        },
        getStatistics(cancelToken = null){
            return BaseRequest.axiosInst.get(
                `${API_URL}/statistics`,
                { headers: BaseRequest.publicHeaders(), cancelToken }
            );
        },
        getOpetationsDaysYears(cancelToken = null){
            return BaseRequest.axiosInst.get(
                `${API_URL}/statistics/operating-days-years`,
                { headers: BaseRequest.publicHeaders(), cancelToken }
            );
        },
        getOperatingDaysStatistics(selectedYear, cancelToken = null) {
            return BaseRequest.axiosInst.get(
                `${API_URL}/statistics/operating-days-statistics?year=${selectedYear}`,
                { headers: BaseRequest.publicHeaders(), cancelToken }
            );
        },
        getActiveUsersByLibStatistics(cancelToken = null) {
            return BaseRequest.axiosInst.get(
                `${API_URL}/statistics/active-users-by-lib-statistics`,
                { headers: BaseRequest.publicHeaders(), cancelToken }
            );
        },
        getActiveUsersByCategStatistics(cancelToken = null) {
            return BaseRequest.axiosInst.get(
                `${API_URL}/statistics/active-users-by-categ-statistics`,
                { headers: BaseRequest.publicHeaders(), cancelToken }
            );
        },
        getActiveUsersByOrgUnitStatistics(page = 1, order = 1, cancelToken = null) {
            return BaseRequest.axiosInst.get(
                `${API_URL}/statistics/active-users-by-org-unit-statistics?order=${order}&page=${page}`,
                { headers: BaseRequest.publicHeaders(), cancelToken }
            );
        },
        getCircMatByInstStatistics(year ,option , cancelToken = null) {
            return BaseRequest.axiosInst.get(
                `${API_URL}/statistics/circ-mat-by-inst?year=${year}&option=${option}`,
                { headers: BaseRequest.publicHeaders(), cancelToken }
            );
        },
        getLibraries(cancelToken = null) {
            return BaseRequest.axiosInst.get(
                `${API_URL}/statistics/circ-mat-libraries`,
                { headers: BaseRequest.publicHeaders(), cancelToken }
            );
        },
        getCircMatByLibStatistics(year ,option, library, cancelToken = null) {
            return BaseRequest.axiosInst.get(
                `${API_URL}/statistics/circ-mat-by-lib?year=${year}&option=${option}&library=${library}`,
                { headers: BaseRequest.publicHeaders(), cancelToken }
            );
        },
        getTurnstileStatistics(library, year, month, cancelToken = null) {
            return BaseRequest.axiosInst.get(
                `${API_URL}/statistics/turnstile-statistics?library=${library}&year=${year}&month=${month}`,
                { headers: BaseRequest.publicHeaders(), cancelToken }
            );
        },
        getWorkTypes(cancelToken = null){
            return BaseRequest.axiosInst.get(
                `${API_URL}/statistics/work-types`,
                { headers: BaseRequest.publicHeaders(), cancelToken }
            );
        },
        getCopyStatus(cancelToken = null){
            return BaseRequest.axiosInst.get(
                `${API_URL}/statistics/copy-status`,
                { headers: BaseRequest.publicHeaders(), cancelToken }
            );
        },
        getCollectionStatus(cancelToken = null){
            return BaseRequest.axiosInst.get(
                `${API_URL}/statistics/collection-status`,
                { headers: BaseRequest.publicHeaders(), cancelToken }
            );
        },
        getGeneralCollectionStatistics(libraries, workTypes, copyStatus, collectionStatus,  cancelToken = null){
            return BaseRequest.axiosInst.post(
                `${API_URL}/statistics/general-collections`,
                { libraries, workTypes, copyStatus, collectionStatus },
                { headers: BaseRequest.publicHeaders(), cancelToken }
            );
        },
        getMecQ83CollectionStatistics(library, year, copyStatus, collectionStatus, searchType,  cancelToken = null){
            return BaseRequest.axiosInst.post(
                `${API_URL}/statistics/collection-mecQ83`,
                { library, year, copyStatus, collectionStatus, searchType },
                { headers: BaseRequest.publicHeaders(), cancelToken }
            );
        },
        autoComplete(term, searchBy, cancelToken = null){
            return BaseRequest.axiosInst.get(
                `${API_URL}/consulta/auto-complete`,
                {
                    headers: BaseRequest.privateOrPublicHeaders(),
                    params: { term, searchBy },
                    cancelToken
                },
            );
        },
        getTypeOptionsAtosNormativosSearch(cancelToken = null){
            return BaseRequest.axiosInst.get(
                `${API_URL}/consulta/opcoes-tipos-atos-normativos`,
                {
                    headers: BaseRequest.publicHeaders(),
                    cancelToken
                },
            );
        },
        getPermissionFiltersAtosAndJurisprudencia(cancelToken = null){
            return BaseRequest.axiosInst.get(
                `${API_URL}/consulta/permissao-filtros-atos-jurisprudencia`,
                {
                    headers: BaseRequest.publicHeaders(),
                    cancelToken
                },
            );
        },
        getTypeOptionsJurisprudenciaSearch(cancelToken = null){
            return BaseRequest.axiosInst.get(
                `${API_URL}/consulta/opcoes-tipos-jurisprudencia`,
                {
                    headers: BaseRequest.publicHeaders(),
                    cancelToken
                },
            );
        }
    };
};
export default ConsultaRequest();
